import axios from 'axios'
axios.defaults.baseURL = 'http://111.229.214.104:8000'
// const Base64 = require('js-base64').Base64

const state = {
videoUrl:''
}

const mutations = {
GET_VIDEO() {
console.log("里面什么也没有")
}
}

const actions = {
	getVideo ({ commit },Id) {
    commit('GET_VIDEO')
		return axios.get('/book/video/?'+ Id ).then((response) => {
      // const exStr = Base64.encode(response.data.video_url)
      // sessionStorage.setItem('hhh',exStr)
      // console.log()
      // sessionStorage.setItem('hhhh',exStr)
      // sessionStorage.setItem('hhhhhh',response.data.video_url)
      // sessionStorage.setItem('eee',response.data.image)
			return response
		})
	}
}
// let url = Base64.decode(sessionStorage.getItem('hhh'))

const getters = {
// getVideUrl(state) {
//   let url = state.videoUrl
//   return url
// }
}

const VideoModule = {
  state,
  mutations,
  actions,
  getters
}

export default VideoModule
